import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MapPin } from "lucide-react";

const initialForm = { name: "", phone: "", email: "", jobTitle: "", company: "", city: "", message: "" };

const ContactPage = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => window.scrollTo(0, 0), []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please fill in your name, email and message.");
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      const existing = JSON.parse(localStorage.getItem("zoofy_leads") || "[]");
      existing.push({ ...form, submittedAt: new Date().toISOString() });
      localStorage.setItem("zoofy_leads", JSON.stringify(existing));
      toast.success("Thank you! Our team will reach out to you shortly.");
      setForm(initialForm);
      setSubmitting(false);
    }, 700);
  };

  const inputCls =
    "w-full bg-[#0b2044] border border-white/10 rounded-lg px-4 py-3.5 text-white placeholder:text-white/35 text-[15px] focus:outline-none focus:border-white/70 focus:ring-1 focus:ring-white/40 transition-colors";
  const labelCls = "block text-[11px] uppercase tracking-[0.14em] text-white/50 mb-2";

  return (
    <main className="bg-[#050f24] min-h-screen">
      <section className="relative pt-40 pb-24 overflow-hidden">
        <div className="absolute right-0 top-10 w-[600px] h-[600px] rounded-full bg-blue-600/15 blur-3xl" />
        <div className="absolute left-1/4 bottom-0 w-[400px] h-[400px] rounded-full bg-white/8 blur-3xl" />

        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.3fr] gap-16">
          <div>
            <p className="text-white text-sm font-semibold tracking-wide uppercase mb-4">Contact Us</p>
            <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-bold mb-6" style={{ fontFamily: "Archivo, sans-serif" }}>
              Let's Connect.
            </h1>
            <p className="text-white/70 leading-relaxed max-w-md">
              Reach out to us for any questions or support. Our dedicated team is here to provide prompt and helpful assistance.
            </p>
            <div className="mt-10 space-y-5">
              <div className="flex items-center gap-4 text-white/80">
                <span className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center"><Mail size={19} className="text-white" /></span>
                connect@zoofytechx.com
              </div>
              <div className="flex items-center gap-4 text-white/80">
                <span className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center"><Phone size={19} className="text-white" /></span>
                +91 120 4555 800
              </div>
              <div className="flex items-center gap-4 text-white/80">
                <span className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center"><MapPin size={19} className="text-white" /></span>
                ZoofyTechX Tower, Noida, India
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-5">
              <input name="name" value={form.name} onChange={handleChange} placeholder="Full name" className={inputCls} />
              <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone number" className={inputCls} />
            </div>
            <div className="mt-5">
              <label className={labelCls}>Email Address</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email address" className={inputCls} />
            </div>
            <div className="grid sm:grid-cols-2 gap-5 mt-5">
              <div>
                <label className={labelCls}>Job Title</label>
                <input name="jobTitle" value={form.jobTitle} onChange={handleChange} placeholder="Job title" className={inputCls} />
              </div>
              <div>
                <label className={labelCls}>Company</label>
                <input name="company" value={form.company} onChange={handleChange} placeholder="Company" className={inputCls} />
              </div>
            </div>
            <div className="mt-5">
              <label className={labelCls}>City</label>
              <input name="city" value={form.city} onChange={handleChange} placeholder="City" className={inputCls} />
            </div>
            <div className="mt-5">
              <label className={labelCls}>Message</label>
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Enter your message" rows={4} className={`${inputCls} resize-none`} />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="mt-7 bg-white hover:bg-[#d7e3f4] disabled:opacity-60 text-[#04122e] text-[15px] font-bold px-9 py-3.5 rounded-lg transition-colors shadow-[0_0_24px_rgba(255,255,255,0.3)]"
              data-testid="contact-submit"
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
